<template>
    <div class="system">
        <el-container>
            <el-aside class="left flex-start column items">
                <!-- <div :class="[activeIndex==1?'active':'']" class=" nav flex-center items" @click="activeIndexFun(1)">
                    <img
                        src="../../assets/images/backstageManagement/system1_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>用户管理</span>
                </div>
                <div :class="[activeIndex==2?'active':'']" class=" nav flex-center items" @click="activeIndexFun(2)">
                    <img
                        src="../../assets/images/backstageManagement/system_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>日志管理</span>
                </div> -->
                <div :class="[activeIndex==3?'active':'']" class=" nav flex-center items" @click="activeIndexFun(3)">
                    <img
                        src="../../assets/images/backstageManagement/system_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>轮播图</span>
                </div>
                <div :class="[activeIndex==4?'active':'']" class=" nav flex-center items" @click="activeIndexFun(4)">
                    <img
                        src="../../assets/images/backstageManagement/system_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>主营业务</span>
                </div>
                <div :class="[activeIndex==5?'active':'']" class=" nav flex-center items" @click="activeIndexFun(5)">
                    <img
                        src="../../assets/images/backstageManagement/system_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>合作用户</span>
                </div>
                <div :class="[activeIndex==6?'active':'']" class=" nav flex-center items" @click="activeIndexFun(6)">
                    <img
                        src="../../assets/images/backstageManagement/system_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>加盟申请</span>
                </div>
                <div :class="[activeIndex==7?'active':'']" class=" nav flex-center items" @click="activeIndexFun(7)">
                    <img
                        src="../../assets/images/backstageManagement/system_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>产品中心</span>
                </div>
            </el-aside>
            <el-main class="right">
                <first ref="firstChild" v-if="activeIndex == 1"></first>
                <two ref="twoChild" v-if="activeIndex == 2"></two>
                <third ref="thirdChild" v-if="activeIndex == 3"></third>
                <four ref="fourChild" v-if="activeIndex == 4"></four>
                <five ref="fiveChild" v-if="activeIndex == 5"></five>
                <six ref="sixChild" v-if="activeIndex == 6"></six>
                <seven ref="sevenChild" v-if="activeIndex == 7"></seven>
                <!-- <two></two> -->
            </el-main>
        </el-container>
    </div>
</template>
<script>
import first from "./subgroup/system_first";
import two from "./subgroup/system_two";
import third from "./subgroup/system_Rotation";
import four from "./subgroup/system_Business";
import five from "./subgroup/system_Cooperation";
import six from "./subgroup/system_Join";
import seven from "./subgroup/system_Product";
export default {
    components: {
        first,
        two,
        third,
        four,
        five,
        six,
        seven
    },
    data() {
        return {
            search: "",
            activeIndex:3
        };
    },
    created() {},
    methods: {
        handleClick(row) {
            //console.log(row);
        },
        activeIndexFun(index){
            if(index != this.activeIndex){
                this.activeIndex = index
            }
        },
    }
};
</script>
<style lang="less" scoped>
.system {
    font-family: "微软雅黑";
    height: calc(~"100vh - 60px");
    .el-icon-search{
        cursor: pointer !important;
    }
    .el-container {
        height: 100%;
    }
    /deep/ .input_box{
        overflow: hidden;
    }
    .left {
        .nav {
            width: 180px;
            height: 40px;
            cursor:pointer;
            // margin-right: 10px;
            border-radius: 20px;
            font-size: 16px;
            .icon {
                width: 20px;
                height: 20px;
                margin-right: 12px;
            }
            margin-bottom: 10px;
            margin-right: 10px;
        }
        .nav-child {
            padding-bottom: 10px;
            height: 36px;
            width: 170px;
            box-sizing: border-box;
            padding-left: 40px;
            font-size: 15px;
            .circle {
                width: 8px;
                height: 8px;
                border-radius: 4px;
                border: 1px solid #fff;
                box-sizing: border-box;
            }
            .num {
                background: #007eff;
                width: 20px;
                height: 20px;
                font-size: 13px;
                border-radius: 10px;
            }
            .text {
                height: 1em;
                line-height: 1em;
                font-size: 14px;
                width: 65px;
            }
        }
        .active {
            background: rgba(0, 126, 255, 1);
        }
    }
    .right {
        .primary {
            width: 80px;
            height: 30px;
            background: rgba(0, 145, 255, 1);
            box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
            border-radius: 4px;
            padding: 0;
        }
        .input_box {
            width: 300px;
            height: 36px;
            border: 1px solid rgba(153, 194, 255, 1);
            border-radius: 4px;
            input {
                width: 270px;
                height: 36px;
                line-height: 36px;
                font-style: italic;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                box-sizing: border-box;
                padding-left: 10px;
            }
        }
    }
    /deep/ .el-dialog__title {
        color: #0074cc !important;
    }
    // /deep/.block_box {
    //     display: block;
    //     .el-form-item {
    //         width: 100%;
    //     }
    //     .el-form-item__content {
    //         width: calc(100% - 70px);
    //     }
    // }
    /deep/.el-dialog__body{
        padding: 30px 40px;
    }
    /deep/.system_box{
        display: flex;
        justify-content: center;
        // flex-direction: column;
        flex-wrap: wrap;
         .el-form-item{
            width: 50%;
        }
    }
    /deep/ .ql-editor {
        min-height: 150px;
    }
    /deep/ .el-dialog__close {
        background: rgba(0, 148, 255, 1);
        border-radius: 4px;
        color: #fff;
    }
    /deep/ .dialog-footer {
        .el-button {
            width: 80px;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(0, 145, 255, 1);
            box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
            border-radius: 4px;
            padding: 0;
            color:#0091FF;

        }
        .el-button1{
            width:80px;
            height:30px;
            background:rgba(0,126,255,1);
            border:1px solid rgba(0,145,255,1);
            box-shadow:0px 1px 3px 0px rgba(0,72,128,0.3);
            border-radius:4px;
            color: #fff;
            margin-left: 10px;
        }
    }
}

.flex-center {
    display: flex;
    justify-content: center;
}
.flex-start {
    display: flex;
    justify-content: flex-start;
}
.items {
    align-items: center;
}
.column {
    flex-direction: column;
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.flex-end {
    display: flex;
    justify-content: flex-end;
}
/deep/ input:-webkit-autofill,
    /deep/  input:-webkit-autofill:hover,
     /deep/ input:-webkit-autofill:focus, 
     /deep/ input:-webkit-autofill:active {
        transition-delay: 99999s;
          transition: color 99999s ease-out, background-color 99999s ease-out;
          -webkit-transition-delay: 99999s;
          -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
          -webkit-text-fill-color: #333;
      }
</style>
